module.exports = __webpack_public_path__ + "static/img/s3en.f95f682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/samSet/s3en.png
// module id = ThCS
// module chunks = 0